// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2H2V8H22V2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 10H11V22H22V10Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9 22V10H2V22H9Z"}}]};

const TemplateFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'template-filled',
    ref,
    icon: element,
  },
));

TemplateFilledIcon.displayName = 'TemplateFilledIcon';

export default TemplateFilledIcon;
